import { RootDispatch, RootGetState } from "../types";
import history from "../../history";
import { post } from "../../utils/fetch";

export type Action =
  | { type: "scheduleVideoChat/scheduleVideoChat-started" }
  | { type: "scheduleVideoChat/scheduleVideoChat-success" }
  | { type: "scheduleVideoChat/scheduleVideoChat-failure" };

export const scheduleVideoChat = (file: FormData) => async (
  dispatch: RootDispatch,
  getState: RootGetState
) => {
  dispatch({
    type: "scheduleVideoChat/scheduleVideoChat-started"
  });

  const url = "/api/organization/" + getState().orgs.currentOrganization?.id + "/patients/";

  const resp = await post(url, file);

  if (resp.error) {
    dispatch({
      type: "scheduleVideoChat/scheduleVideoChat-failure",
      error: resp.error.message
    });
  } else if (resp.data || resp.status === 201) {
    dispatch({
      type: "scheduleVideoChat/scheduleVideoChat-success"
    });
    history.push("/dashboard/");
  } else {
    // TODO Logging
  }
};
